import { getTranslatedText } from './helpers';
import { isEmpty } from 'lodash';

const getProcessedIntegrationOptions = ({
  configuredIntegrations,
  asset,
  intl
}) => {
  const processedOptions = [];
  if (!isEmpty(configuredIntegrations)) {
    configuredIntegrations.forEach((integration) => {
      const {
        teamViewerIntegrated,
        cwcIntegrated,
        primaryMac,
        splashtopIntegrated,
        islIntegrated
      } = asset;
      switch (integration.integrationId) {
        case 'TEAM_VIEWER':
          if (teamViewerIntegrated) {
            processedOptions.push({
              name: 'TEAM_VIEWER',
              label: getTranslatedText(intl, 'integrations.teamviewer')
            });
          }

          break;
        case 'CONNECT_WISE_CONTROL':
          if (cwcIntegrated) {
            processedOptions.push({
              name: 'CONNECT_WISE_CONTROL',
              label: getTranslatedText(intl, 'integrations.connectWiseControl')
            });
          }
          break;
        case 'SUPEROPS_SPLASH_TOP':
          if (
            integration.ownLicense ||
            (splashtopIntegrated &&
              asset?.remoteDesktopEnabledStatus?.SUPEROPS_SPLASH_TOP)
          ) {
            processedOptions.push({
              name: 'SUPEROPS_SPLASH_TOP',
              label: getTranslatedText(intl, 'integrations.splashtop')
            });
          }
          break;
        case 'SPLASH_TOP':
          if (primaryMac) {
            processedOptions.push({
              name: 'SPLASH_TOP',
              label: getTranslatedText(intl, 'integrations.splashtop')
            });
          }
          break;
        case 'ISL':
          if (
            integration.ownLicense ||
            (islIntegrated && asset?.remoteDesktopEnabledStatus?.ISL)
          ) {
            processedOptions.push({
              name: 'ISL',
              label: getTranslatedText(intl, 'integration.isl.name.remote')
            });
          }
          break;
        default:
          break;
      }
    });
  }

  return processedOptions;
};

export { getProcessedIntegrationOptions };
